<script context="module">
    import { paqData } from './OfferSchema.svelte';
    export const principalStreamersNames = [
        'ViX Premium M',
        'Netflix 2S M',
        'Netflix 4S M',
        'Combo+ M',
        'HBO Max M',
        'Netflix 1S M',
        'Netflix_Add M',
        'Max (OTT)',
        'Max basico con anuncios M',
    ];
    export const env = {
        stage: 'prod',
        dev: {
            api: {
                url: 'https://test.izziapiweb.mx/',
                key: 'X28E1r29Gg6sKRq47f5H78qRv52eONF4',
            },
            apiAutoInstall: {
                url: 'https://test.izziapiweb.mx/',
                key: 'X28E1r29Gg6sKRq47f5H78qRv52eONF4',
            },
            apiStore: {
                key: 'srXXhOLHJWpiYFTOPerXYTmc7mEtosXI',
                cookie: 'AWSALB=A6fN3f7COfWJYjVkcRNut90oRbrKYStBeOQSwOrVSh1ZcO7CB47zGDmsa3pErg/VlkUpKF8+u1HEiSwfIxoMijDQcWj3QciVNIXGf7huBRFyAJmQmfI4fz5XsgYI; AWSALBCORS=A6fN3f7COfWJYjVkcRNut90oRbrKYStBeOQSwOrVSh1ZcO7CB47zGDmsa3pErg/VlkUpKF8+u1HEiSwfIxoMijDQcWj3QciVNIXGf7huBRFyAJmQmfI4fz5XsgYI',
                sku: '34359',
            },
            apiFiles: {
                key: 'LvBAPM3WDAO8d9hMBDFWvDsiRk28tvas',
            },
            apiMvno: {
                url: 'https://test.izziapiweb.mx/izziuxp-web-oc/v1/api',
                key: 'da2-xiswyvcqqbadfm5ygtlkcnxqom',
            },
            urlweb: 'https://192.168.23.177:8180',
            urlIzziWeb: 'https://qaizzi.izzi.mx',
            urlIzziWebAccount: 'https://qaizzi.izzi.mx/webApps/registro',
            urlIzziWebPayList: 'https://qaizzi.izzi.mx/dondepagar',
            urlSkyWeb: 'https://skynedagwwebint.sky.com.mx',
            urlIzziTerms: 'https://qaizzi.izzi.mx/legales',
            apiPayPal: {
                url: 'https://192.168.23.177:8180',
                paymentStatus: '/paypal/payment/',
                script: '/paypal/getPaypalScript',
                createOrder: '/paypal/createOrder/',
                captureOrder: '/paypal/captureOrder/',
                cancelOrder: '/paypal/cancelOrder/',
                captureBA: '/paypal/captureBA/',
                cancelBA: '/paypal/cancelBA/',
                platform: 'WEB_PA',
                channel: 'IZZI-VL',
            },
            apiMaps: {
                key: 'AIzaSyD-eoqjwSEEiNrhDLflqPm5hBsLaUTGSXI',
            },
        },
        prod: {
            api: {
                url: 'https://prod.izziapiweb.mx/',
                key: 'bW2Z8i8fT8LhxyXlOPMCezzckCpvCPIu'
            },
            apiAutoInstall: {
                url: 'https://prod.izziapimvno.mx/',
            },
            apiStore: {
                key: 'srXXhOLHJWpiYFTOPerXYTmc7mEtosXI',
                cookie: 'AWSALB=A6fN3f7COfWJYjVkcRNut90oRbrKYStBeOQSwOrVSh1ZcO7CB47zGDmsa3pErg/VlkUpKF8+u1HEiSwfIxoMijDQcWj3QciVNIXGf7huBRFyAJmQmfI4fz5XsgYI; AWSALBCORS=A6fN3f7COfWJYjVkcRNut90oRbrKYStBeOQSwOrVSh1ZcO7CB47zGDmsa3pErg/VlkUpKF8+u1HEiSwfIxoMijDQcWj3QciVNIXGf7huBRFyAJmQmfI4fz5XsgYI',
                sku: "35223"
            },
            apiFiles: {
                key: 'LvBAPM3WDAO8d9hMBDFWvDsiRk28tvas'
            },
            apiMvno: {
                url: 'https://prod.izziapiweb.mx/izziuxp-web-oc/v1/api',
                key: 'da2-xiswyvcqqbadfm5ygtlkcnxqom',
            },
            urlweb: 'https://web.izzidigital.mx',
            urlIzziWeb: 'https://www.izzi.mx',
            urlIzziWebAccount: 'https://www.izzi.mx/webApps/registro',
            urlIzziWebPayList: 'https://www.izzi.mx/dondepagar',
            urlSkyWeb: 'https://www.sky.com.mx',
            urlIzziTerms: 'https://www.izzi.mx/legales',
            apiPayPal:{
                url: 'https://prod.izziapiweb.mx',
                key: 'bW2Z8i8fT8LhxyXlOPMCezzckCpvCPIu',
                paymentStatus:'/pago-primer-mensualidad/paypal/payment/',
                script: '/pago-primer-mensualidad/paypal/getPaypalScript',
                createOrder: '/pago-primer-mensualidad/paypal/createOrder/',
                captureOrder: '/pago-primer-mensualidad/paypal/captureOrder/',
                cancelOrder: '/pago-primer-mensualidad/paypal/cancelOrder/',
                captureBA: '/pago-primer-mensualidad/paypal/captureBA/',
                cancelBA: '/pago-primer-mensualidad/paypal/cancelBA/',
                platform: 'WEB_PA',
                channel: 'IZZI-VL'
            },
            apiMaps: {
                key: 'AIzaSyD-eoqjwSEEiNrhDLflqPm5hBsLaUTGSXI',
            },
        },
        paqData,
        cleanstore: {
            settings: {
                advancedConfigurationMode: true,
                location: {},
            },
            requestedAddress: {
                postalCode: '',
                offnetCoverage: false,
                offnetIzziCoverage: true,
                offnetSkyCoverage: false,
                addressId: '',
                street: '',
                suburb: '',
                city: '',
                state: '',
                externalNumber: '',
                internalNumber: '',
                addressReference: '',
                addressString: '',
                housingUnit: '',
                betweenStreets1: '',
                betweenStreets2: '',
                municipality: '',
                addressQuery: '',
                addressRPT: '',
                billing: false,
                billingPostalCode: '',
                billingCity: '',
                billingSettlement: '',
                billingStreet: '',
                billingExteriorNumber: '',
                billingInteriorNumber: '',
                billingState: '',
                latitude: '',
                longitude: '',
                offerError: false,
            },
            personalDetails: {
                nombre: '',
                segundoNombre: '',
                apPaterno: '',
                apMaterno: '',
                correo: '',
                password: '',
                numeroCelular: '',
                isForeign: false,
                curp: '',
                pasaporte: '',
                giroNegocio: '',
                razonSocial: '',
                portabilityCheck: false,
                portabilityNumber: '',
                billing: false,
                rfc: '',
                codigoCfdi: '',
                regimenFiscal: '',
                codigoVerificacion: '',
            },
            requestedServices: {
                autoinstalacion: false,
                deliveryType: '',
                isVix: false,
                isNetflix: false,
                isHBO: false,
                isHBOAdds: false,
                isSpMovil: false,
                isSky: false,
                productId: '',
                product: null,
                channelExtras: [],
                tvExtensionsExtras: [],
                phoneExtras: [],
                phoneExtensionsExtras: [],
                isAutoinstallation: true,
                promotions: [],
                izzimovil: [],
                total: '?',
                totalOriginal: '?',
                productObject: {
                    productId: null,
                    productFamily: null,
                    productSpeed: null,
                },
            },
            purchaseStatus: {
                accountNumber: '',
                accountNumber10D: '',
                processId: '',
                transactionId: '',
                status: '',
                finalized: false,
                installationDate: '',
                installationTime: '',
                installationExpress: false,
                paymentType: 'ONLINE',
                paymentReference: '',
                paypalPaymentScriptURL: null,
                paypalPaymentReference: '',
                paypalBillingAgreement: null,
                paypalCompleteAgreement: false,
                paypalStatus: '',
                paypalMessage: '',
                paypalMessageAgreement: '',
            },
        },
        cleanstore_offer: {
            dateLoaded: new Date(),
            loadedOffer: {},
        },
        defaultRedirectionToken:
            'eyJhZGRyZXNzSWQiOiI1MDM1NTM4XzAiLCJwb3N0YWxDb2RlIjoiMDEyMTkiLCJhZGRyZXNzU3RyaW5nIjoiSkFWSUVSIEJBUlJPUyBTSUVSUkEgNTQwIFRPUlJFIElJIFBBUksgUExBWkEsICBQSVNPIDgsIExPTUFTIERFIFNBTlRBIEZFIn0=',
        redirectTokenWithProductId:
            'eyJhZGRyZXNzSWQiOiI1MDM1NTM4XzAiLCJwb3N0YWxDb2RlIjoiMDEyMTkiLCJwcm9kdWN0IjoiMzIwMDciLCJhZGRyZXNzU3RyaW5nIjoiSkFWSUVSIEJBUlJPUyBTSUVSUkEgNTQwIFRPUlJFIElJIFBBUksgUExBWkEsICBQSVNPIDgsIExPTUFTIERFIFNBTlRBIEZFIn0=',
        redirectTokenWithProductIdWithoutTv:
            'eyJhZGRyZXNzSWQiOiI1MDM1NTM4XzAiLCJwb3N0YWxDb2RlIjoiMDEyMTkiLCJwcm9kdWN0IjoiMzIwMDUiLCJhZGRyZXNzU3RyaW5nIjoiSkFWSUVSIEJBUlJPUyBTSUVSUkEgNTQwIFRPUlJFIElJIFBBUksgUExBWkEsICBQSVNPIDgsIExPTUFTIERFIFNBTlRBIEZFIn0=',
        installationSchedule: {
            'Matutino Instalacion 9-14': {
                time: {
                    name: 'Matutino',
                    interval: '9am a 2pm',
                },
            },
            'Vespertino Instalacion 14-18': {
                time: {
                    name: 'Vespertino',
                    interval: '2pm a 6pm',
                },
            },
        },
        classesAddOns: {
            'GOLDEN PREMIER': 'golden-addon',
            INTERNACIONAL: 'internacional-addon',
            'Universal+': 'internacional-addon',
            'Disney+': 'disneyplus-addon',
            'Vix Premium': 'vix-addon',
            'Star+': 'starpremium-addon',
            'Paramount+': 'paramount-addon',
            Max: 'hbomax-addon',
            'Hazlo estándar para Max básico': 'hbomax-addon',
            'Max básico con anuncios': 'hbomax-addon',
            'Acorn TV': 'acorntv-addon',
            'Stingray Karaoke': 'stingraykaraoke-addon',
            'STINGRAY Qello': 'qello-addon',
            Noggin: 'noggin-addon',
            'Starz Play': 'starzplay-addon',
            'Dog TV': 'dogtv-addon',
            'Hazlo Edye': 'edye-addon',
            'Fox Sports Premium': 'fox-sports-premium-addon',
            'NBA League Pass': 'nba-league-pass-addon',
            'Disney+ Premium': 'disney-plus-premium-addon',
            'Disney+ Estándar': 'disney-plus-premium-addon',
            'NFL Sunday Ticket': 'stingraykaraoke-addon',
            'MLB Extra Innings': 'mlb-addon',
            'MLB Extra Innings Hospitality': 'mlb-addon',
        },
        logosAddOns: {
            'GOLDEN PREMIER': '/assets/img/logos/golden-premier-logo.png',
            'Universal+': '/assets/img/logos/universal-plus-logo.png',
            'Netflix Estándar con anuncios':
                '/assets/img/logos/netflix-estandar-anuncios.svg',
            'Netflix Básico': '/assets/img/logos/netflix-basico-white-logo.svg',
            'Netflix Estándar':
                '/assets/img/logos/netflix-estandar-white-logo.svg',
            'Netflix Premium':
                '/assets/img/logos/netflix-premium-white-logo.svg',
            'Disney+': '/assets/img/logos/disneyplus-logo.svg',
            'Vix Premium': '/assets/img/logos/vixpremium-white-logo.svg',
            'Star+': '/assets/img/logos/star-plus-white-logo.svg',
            'Combo+': '/assets/img/logos/combo-logo.svg',
            'Paramount+': '/assets/img/logos/paramount-plus-logo.svg',
            Max: '/assets/img/logos/hbomax-logo.svg',
            'Hazlo estándar para Max básico':
                '/assets/img/logos/hbomax-logo.svg',
            'Max básico con anuncios': '/assets/img/logos/hbomax-logo.svg',
            'Acorn TV': '/assets/img/logos/acorntv-logo.svg',
            'Stingray Karaoke': '/assets/img/logos/stingray-karaoke-logo.svg',
            'STINGRAY Qello': '/assets/img/logos/stingray-qello-logo.svg',
            Noggin: '/assets/img/logos/noggin-logo.svg',
            'Starz Play': '/assets/img/logos/starzplay-logo.svg',
            'Dog TV': '/assets/img/logos/dogtv-logo.svg',
            'Lionsgate+': '/assets/img/logos/lionsgate-logo.svg',
            'Hazlo Edye': '/assets/img/logos/edye-logo.svg',
            'Fox Sports Premium':
                '/assets/img/logos/fox-sports-premium-logo.svg',
            'NBA League Pass':
                '/assets/img/logos/nba-colored-logo-white-text.svg',
            'Disney+ Premium': '/assets/img/logos/disney-shine-logo-white.png',
            'Disney+ Estándar': '/assets/img/logos/disney-shine-logo-white.png',
            'NFL Sunday Ticket': '/assets/img/logos/nfl_sunday_ticket.png',
            'MLB Extra Innings': '/assets/img/logos/mlb-logo.svg',
            'MLB Extra Innings Hospitality': '/assets/img/logos/mlb-logo.svg',
        },
    };
</script>
